import React from 'react';
import styled, { css } from 'styled-components';

import Form from '../Forms/index';
import theme from '../../../style/theme';

const ButtonStyles = styled.button`
  display: flex;
  justify-content: center;
  cursor: pointer;
  background-color: black;
  ${props => props.isVisible && css`
    background-color: ${theme.colors.primary};
  `}
  border: none;
  border-radius: .2em;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 2px;
  text-decoration: none;
  padding: .3em .7em;
  color: #fff;
  transition: ${theme.transitions.default} opacity;
  :hover {
    opacity: 0.8;
  }
  :focus {
    outline: none;
  }
  width: 100%;
  height: 100%;
`;

const LinkStyles = styled.a`
  display: flex;
  justify-content: center;
  cursor: pointer;
  background-color: black;
  ${props => props.isVisible && css`
    background-color: ${theme.colors.primary};
  `}
  border: none;
  border-radius: .2em;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 2px;
  text-decoration: none;
  padding: .3em .7em;
  color: #fff;
  transition: ${theme.transitions.default} opacity;
  :hover {
    opacity: 0.8;
  }
  :focus {
    outline: none;
  }
  width: 100%;
  height: 100%;
`;

const renderForms = (eachForm, dataForms, ID, cls, isLoading, requestingTitle) => {
  if (isLoading && (eachForm.sectionID === ID)) {
    return (
      <Form
        key={requestingTitle}
        text={dataForms.text}
        textWhatsApp={dataForms.textWhatsApp}
        IOEmail={dataForms.IOEmail}
        linkWhatsApp={dataForms.linkWhatsApp}
        titleForm={requestingTitle}
        itens={eachForm.itens}
        hiddenItens={eachForm.hiddenItens}
        close={cls}
      />
    );
  }
  return null;
};

class OpenModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleClick = this.handleClick.bind(this);
    this.close = this.close.bind(this);

    this.state = {
      isLoading: false
    };
  }

  handleClick() {
    this.setState({ isLoading: true });
  }
  close() {
    this.setState({ isLoading: false });
  }

  render() {
    const { isLoading } = this.state;
    const dataForms = this.props.formContent;
    const allForms = dataForms.itensForm;
    const requestingTitle = this.props.sectionTitle;
    const CTA = this.props.buttonCTA;
    const ID = this.props.sectionID;
    const type = this.props.ctatype;
    const linkRedirect = this.props.link;
    const cls = this.close;
    return (
      <div>
        {type === 'formulário' ?
          <ButtonStyles
            isVisible
            disabled={isLoading}
            onClick={!isLoading ? this.handleClick : null}
          >
            {CTA}
            {/* {isLoading ? <Form {...dataForm} close={this.close} /> : null} */}
            {allForms ? allForms.map(eachForm =>
              renderForms(
                eachForm,
                dataForms,
                ID,
                cls,
                isLoading,
                requestingTitle,
              )) : null}
          </ButtonStyles>
          :
          <LinkStyles
            isVisible
            href={linkRedirect}
            target="_blank"
          >
            {CTA}
          </LinkStyles>
        }
      </div>
    );
  }
}
export default OpenModal;



// WEBPACK FOOTER //
// ./src/components/UI/Buttons/openModal.jsx